import { render, staticRenderFns } from "./CarepContracts.vue?vue&type=template&id=5c8df3cd&scoped=true"
import script from "./CarepContracts.vue?vue&type=script&lang=js"
export * from "./CarepContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8df3cd",
  null
  
)

export default component.exports